
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcaster/player",
      function () {
        return require("private-next-pages/broadcaster/player.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broadcaster/player"])
      });
    }
  